<template>
    <div class="welcome" @touchmove.prevent>
        <img :src="musicIcon" class="welcome__music" @click="toggleMusic">
        <!-- 主要内容 -->
        <div class="welcome__cnt">
            <div class="welcome__cnt__count">{{top}}</div>
            <img src="http://cdn.shikehuyu.com/card/welcome-title.png?v=1.0.0" class="welcome__cnt__title">
            <img src="http://cdn.shikehuyu.com/card/welcome-main.png?v=1.0.0" class="welcome__cnt__main">
            <img src="http://cdn.shikehuyu.com/card/welcome-text.png?v=1.0.0" class="welcome__cnt__text">
        </div>
        <img src="http://cdn.shikehuyu.com/card/welcome-enter.png?v=1.0.0" class="welcome__enter" @touchstart.prevent="enter">
        <img src="http://cdn.shikehuyu.com/card/share-logo.png?v=1.0.2" class="welcome__icon">
    </div>
</template>

<script>
export default {
    name: 'welcome',
    data() {
        return {
            top: this.$bus.total,
            musicOn: this.$bus.musicOn,
        };
    },
    methods: {
        enter() {
            this.$router.replace('homepage');
        },
        toggleMusic() {
            this.$bus.toggleMusic();
            this.musicOn = this.$bus.musicOn;
            if (this.musicOn) {
                this.$bus.musicFadeIn('bg', 0, 0.5);
            } else {
                this.$bus.musicFadeOut('bg', 0.5, 0);
            }
        },
    },
    computed: {
        musicIcon() {
            return `http://cdn.shikehuyu.com/card/icon-music-${this.musicOn ? 'on' : 'off'}.png?v=1.0.0`;
        },
    },
    mounted() {
        window.welcome = this;
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';

.welcome {
    @include fullscreen;
    @include bg-cover;
    background-image: url('http://cdn.shikehuyu.com/card/welcome-bg.png?v=1.0.0');
    &__music {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        right: 0;
        width: 12vw;
    }
    &__cnt {
        position: absolute;
        top: 32.15vh;
        left: 50%;
        transform: translate(-50%,0);
        &__count {
            position: absolute;
            bottom: 100%;
            color: #ffe956;
            font-weight: bold;
            left: 50%;
            transform: translate(-50%,-7vw);
            font-size: .25rem;
        }
        &__title {
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translate(-50%,-4vw);
            width: 72vw;
        }
        &__main{
            width: 48.4vw;
        }
        &__text{
            position: absolute;
            width: 74.8vw;
            top: 100%;
            left: 50%;
            transform: translate(-50%,4vw);
        }
    }
    &__enter {
        width: 30vw;
        position: absolute;
        bottom: 16vh;
        left: 50%;
        transform: translate(-50%,0);
    }
    &__icon {
        position: absolute;
        bottom: 8.5vw;
        left: 50%;
        transform: translate(-50%,0);
        width: 76vw;
    }
}
@media screen and (max-height: 602px) {
.welcome {
    &__cnt {
        &__text {
            top: 90%;
        }
    }
    &__enter {
        bottom: 14vh;
        left: 50%;
    }
    &__icon {
        bottom: 5vh;
    }
}
}
</style>



// WEBPACK FOOTER //
// src/components/welcome.vue